import { render } from "./getPrescription.vue?vue&type=template&id=0ddda145&scoped=true"
import script from "./getPrescription.vue?vue&type=script&lang=js"
export * from "./getPrescription.vue?vue&type=script&lang=js"

import "./getPrescription.vue?vue&type=style&index=0&id=0ddda145&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ddda145"]])

export default __exports__